import { render, staticRenderFns } from "./unshipped.vue?vue&type=template&id=0c0042a0&scoped=true"
import script from "./unshipped.vue?vue&type=script&lang=js"
export * from "./unshipped.vue?vue&type=script&lang=js"
import style0 from "./unshipped.vue?vue&type=style&index=0&id=0c0042a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0042a0",
  null
  
)

export default component.exports